<template>
  <div :class="className" :style="{height:height,width:width}" />
</template>

<script>
// 词云
import * as echarts from "echarts"; // echarts theme
import resize from "./mixins/resize";
require("echarts/theme/macarons");
require("echarts-wordcloud");

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart"
    },
    width: {
      type: String,
      default: "100%"
    },
    height: {
      type: String,
      default: "100%"
    },
    WordCloudList: {
      type: Array,
      require: true
    },
    isClick: {
      type: Boolean,
      default: false
    },
    retrieve: {
      type: Boolean,
      default: false
    },
    tit: {
      type: String
    },
    max: {
      type: Number,
      default: 50
    }
  },
  watch: {
    WordCloudList: {
      deep: true,
      handler(val) {
        this.initChart();
      }
    }
  },
  data() {
    return {
      chart: null,
      screenWidth: document.documentElement.clientWidth // 屏幕宽度
    };
  },
  mounted() {
    var _this = this;
    window.onresize = function() {
      // 定义窗口大小变更通知事件
      _this.screenWidth = document.documentElement.clientWidth; // 窗口宽度
    };

    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el, "macarons");
      // this.chart.showLoading()
      if (this.WordCloudList === undefined || !this.WordCloudList.length) {
        return;
      }
      let temp;
      let val = this.screenWidth;
      if (val > 570) {
        temp = this.WordCloudList.slice(0, this.max);
      } else {
        temp = this.WordCloudList.slice(0, 30);
      }

      let data = [];
      temp.forEach((item, index) => {
        let temp = {
          name: item.name,
          value: item.count,
          textStyle: {
            normal: {},
            emphasis: {}
          }
        };
        data.push(temp);
      });
      // this.chart.hideLoading()
      this.chart.setOption({
        title: {
          text: this.tit,
          textStyle: {
            fontSize: 15
          }
        },
        series: [
          {
            type: "wordCloud",
            shape: "circle",
            left: "center",
            top: "center",
            width: "100%",
            height: "100%",
            right: null,
            bottom: null,
            sizeRange: [12, 25],
            rotationRange: [0, 0],
            gridSize: 25,
            drawOutOfBound: false,
            textStyle: {
              normal: {
                fontFamily: "sans-serif",
                color: function() {
                  return (
                    "rgb(" +
                    [
                      Math.round(Math.random() * 160),
                      Math.round(Math.random() * 160),
                      Math.round(Math.random() * 160)
                    ].join(",") +
                    ")"
                  );
                }
              },
              emphasis: {
                shadowBlur: 8,
                shadowColor: "#333"
              }
            },

            // Data is an array. Each array item must have name and value property.
            data: data
          }
        ]
      });
      const that = this;
      if (this.isClick) {
        this.chart.off("click");
        this.chart.on("click", function(data) {
          if (data.name) {
            let datas = data.name;
            localStorage.setItem("val", datas);
            localStorage.setItem("highVal", datas);
            that.$router.push({ name: "Loading", params: { data: datas } });

            // if (that.$route.path.toLowerCase() === "/mobile/detail") {
            //   that.$emit("func", data.name);
            // } else {
            //   let datas = data.name;
            //   localStorage.setItem("val", datas);
            //   localStorage.setItem("highVal", datas);
            //   that.$router.push({ name: "Loading", params: { data: datas } });
            //   // that.$router.push({ name: 'mSearch', query: { key: data.name } })
            // }
          }
        });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Charts/WordcloudChart.vue